module.exports = __webpack_public_path__ + "static/img/weik.4db2a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cases/weik.png
// module id = OAz4
// module chunks = 1